import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath } from "../../config/Constant";
import { setHcommerceStoreSkuData } from "../Reducers/hcommerceReducer";
import { setRenderFlashMessage } from "./appConfigAction";

export const fetchStoreInfo = (sku) => {


    if (!sku) {
        return { status: "ERROR", message: "Store sku not provided" };
    }

    return async (dispatch, getState) => {

        try {
            const { hcommerceStoreSkuData } = getState().storeInfoSlice;
            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const room = await AsyncStorage.getItem('room');

            const payload = {
                header: {
                    sessionToken: sessionToken,
                },
                payload: {
                    storeSku: sku,
                    locationId: 1,
                },
            };

            const response = await clientConfigPath.post("/storeInfo/fetch", payload);

            console.log('API Response:', response);
            if (response.data?.header?.status?.statusCode === "SUCCESS") {
                console.log('Store Info Fetch Success');

                let storeData = hcommerceStoreSkuData[sku] || {};

                const updatedStoreData = {
                    [sku]: {
                        ...storeData,
                        storeData: response.data.payload
                    }
                };

                dispatch(setHcommerceStoreSkuData(updatedStoreData));
                return { status: "SUCCESS" }
            } else {
                console.error('API returned failure status:', response.data);

                return { status: "ERROR", message: response.data?.header?.status?.msg || "Something went wrong" }
            }
        } catch (error) {
            console.error('Error fetching store info:', error);
            return { status: "ERROR", message: "Something went wrong" };
        }
    };
};



export const placeHcomOrder = (storeSku, orderDetails) => {


    return async (dispatch, getState) => {

        const { currentGuestDetails } = getState().guestDetailsSlice;

        const sessionToken = await AsyncStorage.getItem("sessionToken");

        const body_header = {
            dataSource: "guestJourney",
            guestEmail: orderDetails.guestEmail || currentGuestDetails?.guestProfile?.email || "",
            guestToken: currentGuestDetails?.guestToken || "",
            locationId: currentGuestDetails?.location || "",
            loggedinGuestToken: currentGuestDetails?.guestToken || "",
            sessionToken: sessionToken
        }

        const body_payload = {
            storeSku: storeSku,
            guestReservationNumber: currentGuestDetails?.reservationNumber,

            gratitudeTipValue: orderDetails.gratitudeTipValue,
            guestComment: orderDetails.guestComment,
            guestCount: orderDetails.guestCount,
            orderDeliveryAt: orderDetails.orderDeliveryAt,
            orderDeliveryLocationImage: orderDetails.orderDeliveryLocationImage,
            orderDeliveryLocationURL: orderDetails.orderDeliveryLocationURL,
            orderDeliveryTime: orderDetails.orderDeliveryTime,
            orderDetails: { orderItemsList: orderDetails.orderItemsList },
        }



        try {

            const response = await clientConfigPath.post("/storeItems/order", {
                header: body_header,
                payload: body_payload,
            });

            console.log("Order API response:", response);

            const status = response?.data?.header?.status?.code;

            if (status == "SUCCESS") {
                dispatch(setRenderFlashMessage(true, { type: "success", message: "Order placed successfully!!" }));
                return { status: "SUCCESS" };
            } else {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: response?.data?.header?.status?.msg || "Something went wrong" }));
                return { status: "ERROR", message: response?.data?.header?.status?.msg || "Something went wrong" };
            }

        } catch (error) {
            console.error("Error in sendOrder API:", error);
            dispatch(setRenderFlashMessage(true, { type: "danger", message: error.response?.data?.header?.status?.msg || "Something went wrong" }));
            return { status: "ERROR", message: error.response?.data?.header?.status?.msg || "Something went wrong" };
        }
    };
};

